class QuoteService {

    // Order'dan quote oluştur ve PDF kaydet
    async createQuoteWithPDF(quoteData, orderId) {
        try {
            console.log('💾 Backend\'e quote gönderiliyor...', {
                orderId,
                poNumber: quoteData.poNumber, // JH-1225-1329-001
                hasQuoteNumber: !!quoteData.quoteNumber
            });

            // HTML content'i al
            const htmlContent = document.getElementById('quote-template').innerHTML;
            const pdfBase64 = btoa(unescape(encodeURIComponent(htmlContent)));

            const requestBody = {
                orderId: orderId,
                quoteData: quoteData, // ⭐ PO Number zaten içinde: JH-1225-1329-001
                pdfData: pdfBase64,
                generatedBy: localStorage.getItem('userEmail') || 'admin@medidepot.com',
                fileName: `quote-${Date.now()}.pdf`
            };

            const response = await fetch('https://medi-panel.cloud/api/quotes/with-pdf', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP ${response.status}: ${errorText}`);
            }

            const result = await response.json();
            console.log('✅ Backend yanıtı:', result);

            // ⭐ Backend Entity döndürüyorsa, success formatına çevir
            if (result && result.id) {
                return {
                    success: true,
                    id: result.id,
                    quoteNumber: result.quoteNumber,
                    poNumber: result.poNumber,
                    message: "Quote created successfully"
                };
            }

            return result;

        } catch (error) {
            console.error('❌ Quote kaydetme hatası:', error);
            throw error;
        }
    }

    // Order'a ait tüm quote'ları getir (sequence için gerekli)
    async getQuotesByOrder(orderId) {
        try {
            const response = await fetch(`https://medi-panel.cloud/api/quotes/order/${orderId}`);

            if (!response.ok) {
                throw new Error('Quote listesi getirilemedi');
            }
            return await response.json();
        } catch (error) {
            console.error('❌ Quote listesi getirme hatası:', error);
            throw error;
        }
    }

    // Quote PDF indir
    async downloadQuotePDF(quoteId) {
        try {
            const response = await fetch(`https://medi-panel.cloud/api/quotes/${quoteId}/pdf`);

            if (!response.ok) {
                throw new Error('Quote PDF indirilemedi');
            }

            const blob = await response.blob();
            return blob;
        } catch (error) {
            console.error('❌ Quote PDF indirme hatası:', error);
            throw error;
        }
    }

    // ⭐ YENİ: Order için kaçıncı quote olduğunu bul
    async getQuoteSequenceNumber(orderId) {
        try {
            const quotes = await this.getQuotesByOrder(orderId);
            return quotes.length; // 0, 1, 2, ...
        } catch (error) {
            console.error('❌ Quote sequence bulma hatası:', error);
            return 0; // Hata durumunda 0'dan başla
        }
    }
}

export default new QuoteService();